export default {
   path: '/multicotizador/creditos',
   children: [
      {
         path: '',
         name: 'creditos',
         component: () => import('../views/CreditosView.vue'),
      },
   ],
};
